import { render, staticRenderFns } from "./DatePickerFormatted.vue?vue&type=template&id=4dba4f40&scoped=true"
import script from "./DatePickerFormatted.vue?vue&type=script&lang=js"
export * from "./DatePickerFormatted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dba4f40",
  null
  
)

export default component.exports